<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";

import Profile from "./profile";
import WeeklyPremium from "./weekly-premium";
import MonthlyPremium from "./monthly-premium";
import TopInsuranceAgency from "./top-insurance-agencies";
import TodaysTasks from "./todays-tasks";
import Stat from "./stat";
import simplebar from "simplebar-vue";


/**
 * Dashboard Component
 */
export default {
   page: {
      title: "Dashboard",
      meta: [
         {
            name: "description",
            content: appConfig.description,
         },
      ],
   },
   components: {
      Layout,
      PageHeader,
      Profile,
      Stat,
      WeeklyPremium,
      MonthlyPremium,
      TopInsuranceAgency,
      TodaysTasks,
      simplebar
   },
   data() {
      return {
         title: "Dashboard",
         items: [
            {
               text: "Dashboard",
               active: true,
           },        
         ],
         statData: [
            {
               icon: "far fa-address-book",
               title: "Total Contacts",
               value: 0,
               route_link: 'contacts',
            },
            {
               icon: "fas fa-funnel-dollar",
               title: "Total Leads",
               value: 0,
               route_link: 'leads',
            },
            {
               icon: "fas fa-handshake",
               title: "Total Business",
               value: 0,
               route_link: 'customers',
            },
            
         ],

         isLoading: false,
         fullPage: true,
         canCancel: false,
         useSlot: false,
         loader: "spinner",
         color: "#007bff",
         bgColor: "#ffffff",
         height: 128,
         width: 128,
         timeout: 3000, //ms
         fetchingStats: true,
         earningStatus: true,

         profile: {},

         weekly_data: {
            weekly_decrease: null,
            weekly_earnings: null,
            weekly_increase: null,
            series: [],
         },

         monthly_data: {
            monthly_decrease: null,
            monthly_earnings: null,
            monthly_increase: null,
            series: [],
         },

         services_expiring: [],

         top_agencies: [],

         tasks: [],

         token: '',

         loading: false,
         
      };
   },
   mounted() {
    
   },

   created() {
                
      this.fetchDashboard();
   },

   methods: {        

      fetchDashboard() {
         let url = "api/hub/dashboard";
            
         this.getToken();
         this.loading = true;
         this.$axios
         .get(url, { headers: { Authorization: "Bearer " + this.token } })
         .then((res) => {
            var data = res.data.data;
            console.log(data);                 
            this.profile =  data.profile;   

            this.statData[0].value = data.total_contacts;
            this.statData[1].value = data.total_leads;
            this.statData[2].value = data.total_businesses;   

            this.weekly_data.weekly_increase = data.weekly_increase;
            this.weekly_data.weekly_earnings = data.weekly_earnings;
            this.weekly_data.weekly_decrease = data.weekly_decrease;

            if(this.weekly_data.weekly_increase) {
               this.weekly_data.series.push(this.weekly_data.weekly_increase);
            } else {
               this.weekly_data.series.push(this.weekly_data.weekly_decrease);
            }

            this.monthly_data.monthly_increase = data.monthly_increase;
            this.monthly_data.monthly_earnings = data.monthly_earnings;
            this.monthly_data.monthly_decrease = data.monthly_decrease;

            if(this.monthly_data.monthly_increase) {
               this.monthly_data.series.push(this.monthly_data.monthly_increase);
            } else {
               this.monthly_data.series.push(this.monthly_data.monthly_decrease);
            }

            this.services_expiring = data.services_expiring;

            this.top_agencies = data.top_agencies;
            this.tasks = data.tasks;

            //console.log(this.monthly_data);
               
         })
         .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        if(typeof error.response.data.message === 'object') {
                           console.log(error.response.status);
                        } else {
                           this.$swal("", error.response.data.message, "error");
                        }                        
                        
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
         })
         .finally(() => (this.loading = false));
      },

      getToken() {
            if (localStorage.getItem('vc_hub')) {
               var vc_hub =  JSON.parse(localStorage.getItem('vc_hub'));
               if(vc_hub.token) {
                  this.token = vc_hub.token;
               } else {
                  this.$swal("", "Failed to fetch token, please login again", "error");
                  this.$router.push({ name: "login" });
               }
               
            } else {
               this.$swal("", "Session expired, please login again", "error");
               this.$router.push({ name: "login" });
            }
      },        

   },
};
</script>

<template>
   <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
         <div class="col-xl-4">
            <Profile :updating="loading" :profile="profile" />      

            <div class="card">
               <div class="card-body">
                  <h4 class="card-title mb-4">Expiring</h4>
                  <b-tabs pills nav-class="bg-light rounded" content-class="mt-4">
                     <b-tab title="This Week" active>
                        <b-card-text>
                           <simplebar>
                              <table class="table table-centered align-middle">
                                 <tbody>
                                    <tr v-for="data of services_expiring" :key="data.id">
                                       <td>                                       
                                          <div class="round-icon font-size-22 text-danger">
                                             <i v-if="data.id==1" class="bx bx-check-shield"></i>
                                             <i v-if="data.id==2" class="fas fa-certificate"></i>
                                             <i v-if="data.id==3" class="fas fa-percentage"></i>
                                             <i v-if="data.id==4" class="fas fa-stamp"></i>
                                             <i v-if="data.id==5" class="bx bx-spreadsheet"></i>
                                             <i v-if="data.id==6" class="fas fa-file-invoice-dollar"></i>
                                          </div>
                                       </td>
                                      <td>
                                          <div>
                                             <h5 class="font-size-14 mb-1">{{ data.service }}</h5>
                                          
                                          </div>
                                       </td>
                                       <td>
                                          <div class="text-end">
                                             <h5 class="font-size-14 mb-0">{{ data.expiring_this_week }}</h5>
                                          </div>
                                       </td>
                                   
                                    </tr>
                                 </tbody>
                              </table>
                           </simplebar>
                        </b-card-text>
                     </b-tab>
                     <b-tab title="This Month">
                        <b-card-text>
                           <simplebar>
                              <table class="table table-centered align-middle">
                                 <tbody>
                                    <tr v-for="data of services_expiring" :key="data.id">
                                       <td>
                                  
                                          <div class="round-icon font-size-22 text-danger">
                                             <i v-if="data.id==1" class="bx bx-check-shield"></i>
                                             <i v-if="data.id==2" class="fas fa-certificate"></i>
                                             <i v-if="data.id==3" class="fas fa-percentage"></i>
                                             <i v-if="data.id==4" class="fas fa-stamp"></i>
                                             <i v-if="data.id==5" class="bx bx-spreadsheet"></i>
                                             <i v-if="data.id==6" class="fas fa-file-invoice-dollar"></i>
                                          </div>
                                       </td>
                                       <td>
                                          <div>
                                             <h5 class="font-size-14 mb-1">{{ data.service }}</h5>
                                    
                                          </div>
                                       </td>
                                       <td>
                                          <div class="text-end">
                                             <h5 class="font-size-14 mb-0">{{ data.expiring_this_month }}</h5>
                                          </div>
                                       </td>
                                
                                    </tr>
                                 </tbody>
                              </table>
                           </simplebar>
                        </b-card-text>
                     </b-tab>
                  </b-tabs>
               </div>
            </div>
         </div>
         <!-- end col -->
         <div class="col-xl-8">
            <div class="row">
               <div v-for="stat of statData" :key="stat.icon" class="col-md-4">
                  <router-link :to="{ name: stat.route_link }">
                     <Stat :icon="stat.icon" :title="stat.title" :value="stat.value" />
                  </router-link>
               </div>
            </div>
        
            <!-- <MonthlyEarning /> -->

            <div class="row">
               <div class="col-lg-6">
                  <WeeklyPremium :updating="loading" :weekly_data="weekly_data" />
               </div>
               <div class="col-lg-6">
                  <MonthlyPremium :updating="loading" :monthly_data="monthly_data"/>
               </div>
            </div>
            <div class="row">
               <div class="col-lg-6">
                  <TopInsuranceAgency :updating="loading" :agencies="top_agencies" />
               </div>
               <!-- end col -->
          
               <div class="col-lg-6">
                  <TodaysTasks :updating="loading" :tasks="tasks" />
               </div>
               <!-- end col -->
            </div>
         </div>
      </div>
      <!-- end row -->

   </Layout>
</template>
